import axios from "axios";
import {Base_URL} from "../url"

export const fetchTripApprovalData = async () => {
    try {
      const response = await axios.get(`${Base_URL}/ApprovalTrip/ApprovalTripData`);
      return response.data;
    } catch (error) {
      console.error("Error fetching trip approval data:", error);
      throw error;
    }
  };
  
  export const sendTripApprovalRequest = async (tripId) => {
    try {
      await axios.put(`${Base_URL}/ApprovalTrip/UpdateTripAproval?TripId=${tripId}`);
    } catch (error) {
      console.error("Error sending trip approval request:", error);
      throw error;
    }
  };